import { Game } from '../../Core'

import ChangeTurn from './ChangeTurn'
import FederationFlag from './FederationFlag'
import UserShield from './UserShield'
import GlobeAlert from './GlobeAlert'
import MisHeader from './MisHeader'
import HoverComponent from './HoverComponent'
import ErrorPopup from './ErrorPopup'

import { put } from 'redux-saga/effects'

/**
 *  Components module initialization.
 */
function* init() {
  yield loadComponents()
}

/**
 * Load components.
 */
export function* loadComponents() {
  const components = {
    ChangeTurn,
    FederationFlag,
    UserShield,
    GlobeAlert,
    MisHeader,
    HoverComponent,
    ErrorPopup,
  }

  yield put(Game.actions.registerComponents(components))
}

/**
 * Sagas entrypoint.
 */
export function* sagas() {
  yield init()
}
